var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValigetta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 28V6.66667C21.3332 5.95942 21.0522 5.28115 20.5521 4.78105C20.052 4.28095 19.3737 4 18.6665 4H13.3332C12.6259 4 11.9476 4.28095 11.4476 4.78105C10.9475 5.28115 10.6665 5.95942 10.6665 6.66667V28M5.33317 9.33333H26.6665C28.1393 9.33333 29.3332 10.5272 29.3332 12V25.3333C29.3332 26.8061 28.1393 28 26.6665 28H5.33317C3.86041 28 2.6665 26.8061 2.6665 25.3333V12C2.6665 10.5272 3.86041 9.33333 5.33317 9.33333Z",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValigetta);
export default __webpack_public_path__ + "static/media/valigetta.66848bb8c29767e2ac026930aad35069.svg";
export { ForwardRef as ReactComponent };